import React from "react";
import { useNavigate } from "react-router-dom";
import { AddPaymentMethodBase } from "./addPaymentMethodBase";

const AddPaymentMethodStatic = () => {
  const navigate = useNavigate();

  return <AddPaymentMethodBase title={'addCardDetails'} goBack={() => navigate(-1)} />;
};

export default AddPaymentMethodStatic;
